import OptInAfter from "@modules/application/pages/OptIn/OptInAfter";
import { GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

const OptIn = () => {
  return <OptInAfter />;
};

export default OptIn;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale!)),
    },
  };
};
